var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.765,
    height: 24.029,
    viewBox: "0 0 22.765 24.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-download-red",
    transform: "translate(-8.853 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M13.853,16.388V4.265a1.265,1.265,0,1,0-2.529,0V16.388L7.159,12.223A1.265,1.265,0,0,0,5.37,14.012l7.218,7.218,7.218-7.218a1.265,1.265,0,0,0-1.789-1.789Z",
    transform: "translate(7.647)",
    fill: "#db0106"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M4.765,9.5a1.265,1.265,0,0,1,1.265,1.265v2.024A1.771,1.771,0,0,0,7.8,14.559H21.965a1.771,1.771,0,0,0,1.771-1.771V10.765a1.265,1.265,0,0,1,2.529,0v2.024a4.3,4.3,0,0,1-4.3,4.3H7.8a4.3,4.3,0,0,1-4.3-4.3V10.765A1.265,1.265,0,0,1,4.765,9.5Z",
    transform: "translate(5.353 9.941)",
    fill: "#db0106"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.c875d4f1957670b0a209fe9b83988e77.svg";
export { ForwardRef as ReactComponent };